import ActiveBadge from "../../../../../../shared/components/badge/ActiveBadge";
import {
  Card,
  CardContent,
} from "../../../../../../shared/components/card/Card";
import { Separator } from "../../../../../../shared/components/separator/Separator";
import { useTranslation } from "react-i18next";
import UpdateClientDialog from "../update/UpdateClientDialog";
import TableDeleteButton from "../../../../../../shared/components/button/TableDeleteButton";

const ClientDetail = ({ client, onDeletion, onEdit }) => {
  const { t } = useTranslation();

  const DataLabel = ({ data, label }) => (
    <div className="flex flex-row gap-x-2 my-1 px-20">
      <div className="w-1/2 font-bold ml-2">{t(label)}</div>
      <div className="w-1/4">{data}</div>
    </div>
  );

  return (
    <Card className="w-1/2 sm:col-span-2" x-chunk="dashboard-05-chunk-0">
      <CardContent className="pb-3 pt-3 flex flex-row gap-x-10">
        <img
          src={client?.logoPath}
          alt={client?.name}
          width={128}
          height={128}
        />
        <div className="w-full">
          <div className="flex flex-row">
            <div className="w-1/2 text-xl font-bold text-end">
              {client?.name}
            </div>
            <div className="w-1/2 flex flex-row justify-end">
              <UpdateClientDialog client={client} onSubmitHandler={onEdit} />
              <TableDeleteButton onClickHandler={onDeletion} />
            </div>
          </div>
          <Separator className="my-2" />
          <DataLabel data={client?.code} label="clients.detail.box.code" />
          <DataLabel
            data={<ActiveBadge booleanValue={client?.enabled} />}
            label="clients.detail.box.status"
          />
          <DataLabel
            data={client?.ga4PropertyId}
            label="clients.detail.box.ga4PropertyId"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default ClientDetail;
